<template>
	<div v-if="show && performedPreFillCheck" :class="slideInClass">
		<header>
			<div class="jon">
				<Jon/>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="close">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main id="job-questionnaire-main" :class="mainClass" ref="main">
			<div v-if="allDone" class="all-done">
				<Avatar :avatar="avatarRocket"/>
				<div class="all-done-text">
					Yeah, super, du hast alles erledigt!
				</div>
			</div>
			<BreakDisplay
				v-else-if="breakType"
				:type="breakType"
			/>
			<template v-else>
				<div
					v-for="(inquiry, i) in inquiriesToEdit"
					:key="inquiry.id"
					:class="['item-container', inquiry.id, {'d-none': i !== inquiryIndexToEdit}]"
				>
					<div v-if="forcedMessages" class="messages">
						<div
							v-for="(message, j) in forcedMessages"
							:key="'forced-message--' + j + '--' + j"
							:style="{'animation-delay': (j + 's')}"
							class="message"
						>
							<span v-html="message"/>
						</div>
					</div>
					<div v-else class="messages">
						<div
							v-for="(message, j) in getMessages(inquiry.id)"
							:key="'message--' + inquiry.id + '--' + j"
							:style="{'animation-delay': (j + 's')}"
							class="message"
						>
							<span v-html="message"/>
						</div>
					</div>
					<div
						:class="['item-edit', { 'skip': skip }]"
						:style="{'animation-delay': (getMessages(inquiry.id).length + 's')}"
					>
						<Function
							v-if="isItemToEdit('function', i)"
							:class="{'d-none': inquiry.id !== 'function'}"
							:meta="meta"
							:value="getItemData('function')"
							@input="setItemData('function', $event)"
						/>
						<EmploymentMode
							v-if="isItemToEdit('employment-mode', i)"
							:class="{'d-none': inquiry.id !== 'employment-mode'}"
							:meta="meta"
							:value="getItemData('employment-mode')"
							@input="setItemData('employment-mode', $event)"
						/>
						<WorkingTime
							v-if="isItemToEdit('working-time', i)"
							:class="{'d-none': inquiry.id !== 'working-time'}"
							:meta="meta"
							:value="getItemData('working-time')"
							@input="setItemData('working-time', $event)"
						/>
						<CareerLevel
							v-if="isItemToEdit('career-level', i)"
							:class="{'d-none': inquiry.id !== 'career-level'}"
							:meta="meta"
							:value="getItemData('career-level')"
							@input="setItemData('career-level', $event)"
						/>
						<IndustrialSector
							v-if="isItemToEdit('industrial-sector', i)"
							:class="{'d-none': inquiry.id !== 'industrial-sector'}"
							:meta="meta"
							:value="getItemData('industrial-sector')"
							@input="setItemData('industrial-sector', $event)"
						/>
						<OrganisationalArea
							v-if="isItemToEdit('organisational-area', i)"
							:class="{'d-none': inquiry.id !== 'organisational-area'}"
							:meta="meta"
							:value="getItemData('organisational-area')"
							@input="setItemData('organisational-area', $event)"
						/>
						<PlaceOfWork
							v-if="isItemToEdit('place-of-work', i)"
							:class="{'d-none': inquiry.id !== 'place-of-work'}"
							:meta="meta"
							:value="getItemData('place-of-work')"
							@input="setItemData('place-of-work', $event)"
						/>
						<CompanyType
							v-if="isItemToEdit('company-type', i)"
							:class="{'d-none': inquiry.id !== 'company-type'}"
							:meta="meta"
							:value="getItemData('company-type')"
							@input="setItemData('company-type', $event)"
						/>
						<CompanySize
							v-if="isItemToEdit('company-size', i)"
							:class="{'d-none': inquiry.id !== 'company-size'}"
							:meta="meta"
							:value="getItemData('company-size')"
							@input="setItemData('company-size', $event)"
						/>
						<FunctionDetail
							v-if="isItemToEdit('function-detail', i)"
							:class="{'d-none': inquiry.id !== 'function-detail'}"
							:value="getItemData('function-detail')"
							@input="setItemData('function-detail', $event)"
						/>
						<!--
						<FunctionAssistance
							v-if="isItemToEdit('function-assistance', i)"
							:class="{'d-none': inquiry.id !== 'function-assistance'}"
							:meta="meta"
							:value="getItemData('function-assistance')"
							@input="setItemData('function-assistance', $event)"
						/>
						<FunctionMarketingRole
							v-if="isItemToEdit('function-marketing-role', i)"
							:class="{'d-none': inquiry.id !== 'function-marketing-role'}"
							:meta="meta"
							:value="getItemData('function-marketing-role')"
							@input="setItemData('function-marketing-role', $event)"
						/>
						-->
						<FunctionLegalField
							v-if="isItemToEdit('function-legal-field', i)"
							:class="{'d-none': inquiry.id !== 'function-legal-field'}"
							:meta="meta"
							:value="getItemData('function-legal-field')"
							@input="setItemData('function-legal-field', $event)"
						/>
						<!--
						<FunctionLegalRole
							v-if="isItemToEdit('function-legal-role', i)"
							:class="{'d-none': inquiry.id !== 'function-legal-role'}"
							:meta="meta"
							:value="getItemData('function-legal-role')"
							@input="setItemData('function-legal-role', $event)"
						/>
						-->
						<FunctionTaxField
							v-if="isItemToEdit('function-tax-field', i)"
							:class="{'d-none': inquiry.id !== 'function-tax-field'}"
							:meta="meta"
							:value="getItemData('function-tax-field')"
							@input="setItemData('function-tax-field', $event)"
						/>
						<!--
						<FunctionTaxRole
							v-if="isItemToEdit('function-tax-role', i)"
							:class="{'d-none': inquiry.id !== 'function-tax-role'}"
							:meta="meta"
							:value="getItemData('function-tax-role')"
							@input="setItemData('function-tax-role', $event)"
						/>
						-->
						<Salary
							v-if="isItemToEdit('salary', i)"
							:class="{'d-none': inquiry.id !== 'salary'}"
							:value="getItemData('salary')"
							@input="setItemData('salary', $event)"
						/>
						<HourlyRate
							v-if="isItemToEdit('hourly-rate', i)"
							:class="{'d-none': inquiry.id !== 'hourly-rate'}"
							:value="getItemData('hourly-rate')"
							@input="setItemData('hourly-rate', $event)"
						/>
						<WorkingHours
							v-if="isItemToEdit('working-hours', i)"
							:class="{'d-none': inquiry.id !== 'working-hours'}"
							:value="getItemData('working-hours')"
							@input="setItemData('working-hours', $event)"
						/>
						<EmploymentDuration
							v-if="isItemToEdit('employment-duration', i)"
							:class="{'d-none': inquiry.id !== 'employment-duration'}"
							:value="getItemData('employment-duration')"
							@input="setItemData('employment-duration', $event)"
						/>
						<Legitimation
							v-if="isItemToEdit('legitimation', i)"
							:class="{'d-none': inquiry.id !== 'legitimation'}"
							:value="getItemData('legitimation')"
							:job-profile="jobProfile.jobProfile"
							@input="setItemData('legitimation', $event)"
							@confirmMobilePhone="setForcedMessages([
								'SMS für dich!',
								'Bitte bestätige deine Mobilnummer.'
							], true)"
							@checkData="setForcedMessages([
								'Bitte überprüfe deine Angaben',
								'Vorname und Nachname können später nicht mehr geändert werden.'
							], false)"
							@changeData="setForcedMessages(undefined, false)"
							@scrollIntoView="scrollBottom"
							@finish="onFinishLegitimation"
						/>
						<DesireAdditions
							v-if="isItemToEdit('function-experience', i)"
							:class="{'d-none': inquiry.id !== 'function-experience'}"
							:characteristic-type="meta.functionType"
							:characteristic-items="meta.function"
							:desire="getInitialDesires('function', meta.function)"
							:value="getItemData('function-experience')"
							:addition-config="{
								inline: true,
								experience: {
									enabled: true,
									noneAllowed: true
								},
								selfAssessment: {
									enabled: false
								},
								education: {
									enabled: false
								}
							}"
							:supplements-config="{
								nothingAllowed: true,
								types: functionExperienceSupplementTypes
							}"
							:further-messages="[
								'Werden weitere Berufserfahrungen benötigt?'
							]"
							:label-type="labelTypeJobProfile"
							type="job-profile"
							@furtherAppeared="addDisableSkip('function-experience')"
							@additionsEdit="onDesireAdditionsEdit"
							@input="setItemData('function-experience', $event)"
						>
							<template #deleteConfirmText="data">
								Möchtest du die Tätigkeits-Erfahrung
								<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
								wirklich entfernen?
							</template>
						</DesireAdditions>
						<DesireAdditions
							v-if="isItemToEdit('function-legal-field-experience', i)"
							:class="{'d-none': inquiry.id !== 'function-legal-field-experience'}"
							:characteristic-type="meta.functionLegalFieldType"
							:characteristic-items="meta.functionLegalField"
							:desire="getInitialDesires('function-legal-field', meta.functionLegalField)"
							:value="getItemData('function-legal-field-experience')"
							:addition-config="{
								inline: true,
								experience: {
									enabled: true,
									noneAllowed: true
								},
								selfAssessment: {
									enabled: false
								},
								education: {
									enabled: false
								}
							}"
							:further-messages="[
								'Werden weitere Rechtsgebiets-Erfahrungen benötigt?'
							]"
							:label-type="labelTypeJobProfile"
							type="job-profile"
							@furtherAppeared="addDisableSkip('function-legal-field-experience')"
							@input="setItemData('function-legal-field-experience', $event)"
						>
							<template #deleteConfirmText="data">
								Möchtest du die Rechtsgebiets-Erfahrung
								<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
								wirklich entfernen?
							</template>
						</DesireAdditions>
						<!--
						<DesireAdditions
							v-if="isItemToEdit('function-legal-role-experience', i)"
							:class="{'d-none': inquiry.id !== 'function-legal-role-experience'}"
							:characteristic-type="meta.functionLegalRoleType"
							:characteristic-items="meta.functionLegalRole"
							:desire="getInitialDesires('function-legal-role', meta.functionLegalRole)"
							:value="getItemData('function-legal-role-experience')"
							:addition-config="{
								inline: true,
								experience: {
									enabled: false
								},
								selfAssessment: {
									enabled: false
								},
								education: {
									enabled: false
								}
							}"
							:further-messages="[
								'Werden weitere Rechtstätigkeits-Erfahrungen benötigt?'
							]"
							:label-type="labelTypeJobProfile"
							type="job-profile"
							@furtherAppeared="addDisableSkip('function-legal-role-experience')"
							@input="setItemData('function-legal-role-experience', $event)"
						>
							<template #deleteConfirmText="data">
								Möchtest du die Rechtstätigkeits-Erfahrung
								<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
								wirklich entfernen?
							</template>
						</DesireAdditions>-->
						<DesireAdditions
							v-if="isItemToEdit('function-tax-field-experience', i)"
							:class="{'d-none': inquiry.id !== 'function-tax-field-experience'}"
							:characteristic-type="meta.functionTaxFieldType"
							:characteristic-items="meta.functionTaxField"
							:desire="getInitialDesires('function-tax-field', meta.functionTaxField)"
							:value="getItemData('function-tax-field-experience')"
							:addition-config="{
								inline: true,
								experience: {
									enabled: true,
									noneAllowed: true
								},
								selfAssessment: {
									enabled: false
								},
								education: {
									enabled: false
								}
							}"
							:further-messages="[
								'Werden weitere Steuergebiets-Erfahrungen benötigt?'
							]"
							:label-type="labelTypeJobProfile"
							type="job-profile"
							@furtherAppeared="addDisableSkip('function-tax-field-experience')"
							@input="setItemData('function-tax-field-experience', $event)"
						>
							<template #deleteConfirmText="data">
								Möchtest du die Steuergebiets-Erfahrung
								<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
								wirklich entfernen?
							</template>
						</DesireAdditions>
						<!--<DesireAdditions
							v-if="isItemToEdit('function-tax-role-experience', i)"
							:class="{'d-none': inquiry.id !== 'function-tax-role-experience'}"
							:characteristic-type="meta.functionTaxRoleType"
							:characteristic-items="meta.functionTaxRole"
							:desire="getInitialDesires('function-tax-role', meta.functionTaxRole)"
							:value="getItemData('function-tax-role-experience')"
							:addition-config="{
								inline: true,
								experience: {
									enabled: false
								},
								selfAssessment: {
									enabled: false
								},
								education: {
									enabled: false
								}
							}"
							:further-messages="[
								'Werden weitere Steuerstätigkeits-Erfahrungen benötigt?'
							]"
							:label-type="labelTypeJobProfile"
							type="job-profile"
							@furtherAppeared="addDisableSkip('function-tax-role-experience')"
							@input="setItemData('function-tax-role-experience', $event)"
						>
							<template #deleteConfirmText="data">
								Möchtest du die Steuertätigkeits-Erfahrung
								<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
								wirklich entfernen?
							</template>
						</DesireAdditions>
						<DesireAdditions
							v-if="isItemToEdit('function-marketing-role-experience', i)"
							:class="{'d-none': inquiry.id !== 'function-marketing-role-experience'}"
							:characteristic-type="meta.functionMarketingRoleType"
							:characteristic-items="meta.functionMarketingRole"
							:desire="getInitialDesires('function-marketing-role', meta.functionMarketingRole)"
							:value="getItemData('function-marketing-role-experience')"
							:addition-config="{
								inline: true,
								experience: {
									enabled: false
								},
								selfAssessment: {
									enabled: false
								},
								education: {
									enabled: false
								}
							}"
							:further-messages="[
								'Werden weitere Marketingtätigkeits-Erfahrungen benötigt?'
							]"
							:label-type="labelTypeJobProfile"
							type="job-profile"
							@furtherAppeared="addDisableSkip('function-marketing-role-experience')"
							@input="setItemData('function-marketing-role-experience', $event)"
						>
							<template #deleteConfirmText="data">
								Möchtest du die Marketingtätigkeits-Erfahrung
								<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
								wirklich entfernen?
							</template>
						</DesireAdditions>
						-->
						<DesireAdditions
							v-if="isItemToEdit('industrial-sector-experience', i)"
							:class="{'d-none': inquiry.id !== 'industrial-sector-experience'}"
							:characteristic-type="meta.industrialSectorType"
							:characteristic-items="meta.industrialSector"
							:desire="getInitialDesires('industrial-sector', meta.industrialSector)"
							:value="getItemData('industrial-sector-experience')"
							:addition-config="{
								inline: true,
								experience: {
									enabled: true,
									noneAllowed: true
								},
								selfAssessment: {
									enabled: false
								},
								education: {
									enabled: false
								}
							}"
							:further-messages="[
								'Ist weitere Erfahrung in bestimmten Branchen erforderlich?'
							]"
							:label-type="labelTypeJobProfile"
							type="job-profile"
							@furtherAppeared="addDisableSkip('industrial-sector-experience')"
							@input="setItemData('industrial-sector-experience', $event)"
						>
							<template #deleteConfirmText="data">
								Möchtest du die Branchen-Erfahrung
								<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
								wirklich entfernen?
							</template>
						</DesireAdditions>
						<DesireAdditions
							v-if="isItemToEdit('career-level-experience', i)"
							:class="{'d-none': inquiry.id !== 'career-level-experience'}"
							:characteristic-type="meta.careerLevelType"
							:characteristic-items="meta.careerLevel"
							:desire="getInitialDesires('career-level', meta.careerLevel)"
							:value="getItemData('career-level-experience')"
							:addition-config="{
								inline: true,
								experience: {
									enabled: true,
									noneAllowed: true
								},
								selfAssessment: {
									enabled: false
								},
								education: {
									enabled: false
								}
							}"
							:further-messages="[
								'Werden weitere Berufsebenen-Erfahrungen benötigt?'
							]"
							:label-type="labelTypeJobProfile"
							type="job-profile"
							@furtherAppeared="addDisableSkip('career-level-experience')"
							@input="setItemData('career-level-experience', $event)"
						>
							<template #deleteConfirmText="data">
								Möchtest du die Berufsebenen-Erfahrung
								<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
								wirklich entfernen?
							</template>
						</DesireAdditions>
						<Skills
							v-if="isItemToEdit('skills', i)"
							:class="{'d-none': inquiry.id !== 'skills'}"
							:meta="meta"
							:value="getItemData('skills')"
							@input="setItemData('skills', $event)"
						/>
						<HiringDate
							v-if="isItemToEdit('hiring-date', i)"
							:class="{'d-none': inquiry.id !== 'hiring-date'}"
							:value="getItemData('hiring-date')"
							@input="setItemData('hiring-date', $event)"
						/>
						<Language
							v-if="isItemToEdit('language', i)"
							:class="{'d-none': inquiry.id !== 'language'}"
							:meta="meta"
							:value="getItemData('language')"
							@input="setItemData('language', $event)"
						/>
						<SoftwareMain
							v-if="isItemToEdit('software-main', i)"
							:class="{'d-none': inquiry.id !== 'software-main'}"
							:meta="meta"
							:value="getItemData('software-main')"
							@input="setItemData('software-main', $event)"
						/>
						<SoftwareSpecial
							v-if="isItemToEdit('software-special', i)"
							:class="{'d-none': inquiry.id !== 'software-special'}"
							:value="getItemData('software-special')"
							@input="setItemData('software-special', $event)"
						/>
						<Parking
							v-if="isItemToEdit('parking', i)"
							:class="{'d-none': inquiry.id !== 'parking'}"
							:meta="meta"
							:value="getItemData('parking')"
							@input="setItemData('parking', $event)"
						/>
						<Benefits
							v-if="isItemToEdit('benefits', i)"
							:class="{'d-none': inquiry.id !== 'benefits'}"
							:meta="meta"
							:value="getItemData('benefits')"
							@input="setItemData('benefits', $event)"
						/>
						<PublicTransport
							v-if="isItemToEdit('public-transport', i)"
							:class="{'d-none': inquiry.id !== 'public-transport'}"
							:meta="meta"
							:value="getItemData('public-transport')"
							@input="setItemData('public-transport', $event)"
						/>
						<CompanyCar
							v-if="isItemToEdit('company-car', i)"
							:class="{'d-none': inquiry.id !== 'company-car'}"
							:meta="meta"
							:value="getItemData('company-car')"
							@input="setItemData('company-car', $event)"
						/>
						<PrivateVehicleCompanyUsage
							v-if="isItemToEdit('private-vehicle-company-usage', i)"
							:class="{'d-none': inquiry.id !== 'private-vehicle-company-usage'}"
							:meta="meta"
							:value="getItemData('private-vehicle-company-usage')"
							@input="setItemData('private-vehicle-company-usage', $event)"
						/>
						<CustomerContact
							v-if="isItemToEdit('customer-contact', i)"
							:class="{'d-none': inquiry.id !== 'customer-contact'}"
							:meta="meta"
							:value="getItemData('customer-contact')"
							@input="setItemData('customer-contact', $event)"
						/>
						<Management
							v-if="isItemToEdit('management', i)"
							:class="{'d-none': inquiry.id !== 'management'}"
							:meta="meta"
							:value="getItemData('management')"
							@input="setItemData('management', $event)"
						/>
						<Overtime
							v-if="isItemToEdit('overtime', i)"
							:class="{'d-none': inquiry.id !== 'overtime'}"
							:meta="meta"
							:value="getItemData('overtime')"
							@input="setItemData('overtime', $event)"
						/>
						<TravelWillingness
							v-if="isItemToEdit('travel-willingness', i)"
							:class="{'d-none': inquiry.id !== 'travel-willingness'}"
							:meta="meta"
							:value="getItemData('travel-willingness')"
							@input="setItemData('travel-willingness', $event)"
						/>
						<DrivingLicense
							v-if="isItemToEdit('driving-license', i)"
							:class="{'d-none': inquiry.id !== 'driving-license'}"
							:meta="meta"
							:value="getItemData('driving-license')"
							@input="setItemData('driving-license', $event)"
						/>
						<PilotLicense
							v-if="isItemToEdit('pilot-license', i)"
							:class="{'d-none': inquiry.id !== 'pilot-license'}"
							:meta="meta"
							:value="getItemData('pilot-license')"
							@input="setItemData('pilot-license', $event)"
						/>
						<Education
							v-if="isItemToEdit('education', i)"
							:class="{'d-none': inquiry.id !== 'education'}"
							:meta="meta"
							:value="getItemData('education')"
							@input="setItemData('education', $event)"
						/>
						<Citizenship
							v-if="isItemToEdit('citizenship', i)"
							:class="{'d-none': inquiry.id !== 'citizenship'}"
							:meta="meta"
							:value="getItemData('citizenship')"
							@input="setItemData('citizenship', $event)"
						/>
						<HomeOffice
							v-if="isItemToEdit('home-office-advanced', i)"
							:class="{'d-none': inquiry.id !== 'home-office-advanced'}"
							:emit-change-on-mount="true"
							:meta="meta"
							:value="getItemData('home-office-advanced')"
							@input="setItemData('home-office-advanced', $event)"
						/>
					</div>
				</div>
			</template>
		</main>
		<footer v-if="!isLegitimation || breakType" class="align-items-baseline">
			<div class="footer--button-container">
				<div class="flex-grow-1">
					<Button
						v-if="inquiryIndexToEdit > 0 && !finishingItem && !allDone && !hideGoBack"
						text="Zurück"
						secondary
						:disabled="!canGoBack || finishingItem"
						@click="goBack"
					/>
				</div>
				<div class="text-right">
					<div class="d-flex align-items-center justify-content-end">
						<b-form-checkbox
							v-if="canSkip"
							v-model="skip"
							:value="true"
							class="d-none d-md-block mr-2 mt-2 mt-md-0"
						>
							Ich möchte diese Frage später beantworten.
						</b-form-checkbox>
						<Button
							v-if="allDone"
							text="Schließen"
							icon="checkmark"
							@click="close"
						/>
						<Button
							v-else
							text="Weiter"
							icon="checkmark"
							:disabled="!canContinue || finishingItem"
							:loading="finishingItem"
							@click="finishItem"
						/>
					</div>
					<div v-if="isShowItemEditableInfo" class="d-none d-md-block font-size-smaller mt-3">
						Deine Angaben können nachträglich noch geändert werden.
					</div>
				</div>
			</div>
			<div class="d-md-none mt-2">
				<b-form-checkbox
					v-if="canSkip"
					v-model="skip"
					:value="true"
					class="mr-2"
				>
					Ich möchte diese Frage später beantworten.
				</b-form-checkbox>
				<div v-if="isShowItemEditableInfo" class="font-size-smaller mt-3">
					Alle deine Angaben können nachträglich noch geändert werden.
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import {
	default as BreakDisplay,
	TYPE__PRE_EXPERIENCE
} from "@/vue/customer-area/job-profile/questionnaire/BreakDisplay.vue";
import Label from "@/vue/characteristic/Label"
import {mapActions, mapState} from "vuex";
import {getClasses} from "@/helper/layout/Fan";
import DesireAdditions from "@/vue/characteristic/DesireAdditions.vue";
import {OPEN_FAN_KEY} from "@/store/job-profile/questionnaire";
import Icon from "@/vue/icon/Icon";
import * as Inquiry from "@/helper/job-profile/Inquiry";
import Button from "@/vue/common/Button";
import _ from "lodash";
import * as Log from "@/helper/Log";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import TravelWillingness from "@/vue/customer-area/job-profile/edit/TravelWillingness"
import Salary from "@/vue/customer-area/job-profile/edit/Salary"
import HourlyRate from "@/vue/customer-area/job-profile/edit/HourlyRate"
import HomeOffice from "@/vue/customer-area/job-profile/edit/HomeOffice"
import WorkingHours from "@/vue/customer-area/job-profile/edit/WorkingHours"
import EmploymentDuration from "@/vue/customer-area/job-profile/edit/EmploymentDuration"
import Save from "@/api/customer/job-profile/Save";
import {prepare, SOURCE_QUESTIONNAIRE} from "@/helper/job-profile/PreSavePreparation";
import * as PreFillPreparation from "@/helper/job-profile/PreFillPreparation";
import Function from "@/vue/customer-area/job-profile/edit/Function";
import EmploymentMode from "@/vue/customer-area/job-profile/edit/EmploymentMode";
import FunctionExperience from "@/vue/customer-area/job-profile/edit/FunctionExperience";
import CareerLevelExperience from "@/vue/customer-area/job-profile/edit/CareerLevelExperience";
import IndustrialSectorExperience from "@/vue/customer-area/job-profile/edit/IndustrialSectorExperience";
import Skills from "@/vue/customer-area/job-profile/edit/Skills";
import HiringDate from "@/vue/customer-area/job-profile/edit/HiringDate";
import Language from "@/vue/customer-area/job-profile/edit/Language";
import SoftwareMain from "@/vue/customer-area/job-profile/edit/SoftwareMain";
import Parking from "@/vue/customer-area/job-profile/edit/Parking";
import Benefits from "@/vue/customer-area/job-profile/edit/Benefits";
import PublicTransport from "@/vue/customer-area/job-profile/edit/PublicTransport";
import CompanyCar from "@/vue/customer-area/job-profile/edit/CompanyCar";
import PrivateVehicleCompanyUsage from "@/vue/customer-area/job-profile/edit/PrivateVehicleCompanyUsage";
import CustomerContact from "@/vue/customer-area/job-profile/edit/CustomerContact";
import Management from "@/vue/customer-area/job-profile/edit/Management";
import Overtime from "@/vue/customer-area/job-profile/edit/Overtime";
import DrivingLicense from "@/vue/customer-area/job-profile/edit/DrivingLicense";
import PilotLicense from "@/vue/customer-area/job-profile/edit/PilotLicense";
import SoftwareSpecial from "@/vue/customer-area/job-profile/edit/SoftwareSpecial";
import Citizenship from "@/vue/customer-area/job-profile/edit/Citizenship";
import FunctionAssistance from "@/vue/customer-area/job-profile/edit/FunctionAssistance";
import FunctionMarketingRole from "@/vue/customer-area/job-profile/edit/FunctionMarketingRole";
import FunctionLegalField from "@/vue/customer-area/job-profile/edit/FunctionLegalField";
import FunctionLegalRole from "@/vue/customer-area/job-profile/edit/FunctionLegalRole";
import FunctionTaxField from "@/vue/customer-area/job-profile/edit/FunctionTaxField";
import FunctionTaxRole from "@/vue/customer-area/job-profile/edit/FunctionTaxRole";
import FunctionDetail from "@/vue/customer-area/job-profile/edit/FunctionDetail";
import Education from "@/vue/customer-area/job-profile/edit/Education";
import Legitimation from "@/vue/customer-area/job-profile/questionnaire/Legitimation";
import {scrollToBottom} from "@/helper/Window";
import {JOB_PROFILE} from "@/helper/characteristic/Label";
import {findByInquiryId} from "@/helper/job-profile/GroupProvider";
import {byId} from "@/helper/application/characteristic/Provider";
import {isDefined} from "@/helper/Value";
import Jon from "@/vue/common/image/Jon.vue";
import Avatar, {ROCKET} from "@/vue/common/image/Avatar.vue";
import WorkingTime from "@/vue/customer-area/job-profile/edit/WorkingTime.vue";
import CareerLevel from "@/vue/customer-area/job-profile/edit/CareerLevel.vue";
import IndustrialSector from "@/vue/customer-area/job-profile/edit/IndustrialSector.vue";
import PlaceOfWork from "@/vue/customer-area/job-profile/edit/PlaceOfWork.vue";
import CompanyType from "@/vue/customer-area/job-profile/edit/CompanyType.vue";
import CompanySize from "@/vue/customer-area/job-profile/edit/CompanySize.vue";
import OrganisationalArea from "@/vue/customer-area/job-profile/edit/OrganisationalArea.vue";
import {transformSupplements} from "@/helper/job-profile/PreFillPreparation";
import {RELEVANT_SUPPLEMENT_TYPES} from "@/helper/characteristic/Functions";
import GetList from "@/api/customer/job-profile/GetList";
import {DEFAULT_EXPERIENCE_INFO} from "@/helper/job-profile/Experience";
import {EXTERNAL} from "@/helper/customer/Type";

const CONFIG = {
	[Inquiry.FUNCTION]: {
		property: 'functions',
		showItemEditableInfo: false,
		messages: () => [
			'Welchen Job besetzt du?',
		],
	},
	[Inquiry.EMPLOYMENT_MODE]: {
		property: 'employmentMode',
		messages: () => [
			'Welche Job-Art ist das?',
		],
	},
	[Inquiry.WORKING_TIME]: {
		property: 'workingTime',
		messages: () => [
			'Sind spezielle Arbeitszeiten erforderlich?',
		],
	},
	[Inquiry.CAREER_LEVEL]: {
		property: 'careerLevels',
		showItemEditableInfo: false,
		messages: () => [
			'Welche Berufsebene ist das?',
		],
	},
	[Inquiry.INDUSTRIAL_SECTOR]: {
		property: 'industrialSectors',
		showItemEditableInfo: false,
		messages: ({customer}) =>
		{
			return customer.type === EXTERNAL
				? [
					'Zu welcher Branche gehört das Unternehmen für das du suchst?',
					'Welche Leistungen/Produkt bietet diese Organisation?',
				]
				: [
					'Zu welcher Branche gehört ihr?',
					'Welche Leistungen/Produkte bietet ihr?',
				]
		},
	},
	[Inquiry.ORGANISATIONAL_AREA]: {
		property: 'organisationalArea',
		showItemEditableInfo: false,
		messages: () => [
			'In welchem Organisationsbereich ist die Tätigkeit?',
		],
	},
	[Inquiry.PLACE_OF_WORK]: {
		property: 'placeOfWork',
		messages: () => [
			'Wo ist der Arbeitsort für diesen Job?',
			'Mehrfachauswahl möglich, wenn unterschiedliche Arbeitsorte möglich sind.',
			'Wenn großteils Remote/Homeoffice vorgesehen ist, gib bitte Euren Hauptsitz für diesen Job ein.'
		],
	},
	[Inquiry.COMPANY_TYPE]: {
		property: 'companyType',
		messages: ({customer}) =>
		{
			return customer.type === EXTERNAL
				? ['Für welche Organisationsart suchst du?']
				: ['Welche Organisationsart habt ihr?'];
		},
	},
	[Inquiry.COMPANY_SIZE]: {
		property: 'companySize',
		messages: ({customer}) =>
		{
			return customer.type === EXTERNAL
				? ['Wie groß ist die Organisation, für die du suchst?']
				: ['Wie groß ist eure Organisation?'];
		},
	},
	[Inquiry.FUNCTION_DETAIL]: {
		property: 'functionDetail',
		messages: () => [
			'Welche Tätigkeiten umfasst der Job?',
			'Um das Interesse von potentiellen MitarbeiterInnen zu steigern, gib die Tätigkeiten möglichst detailliert an!',
			'<b>ACHTUNG:</b> Dieser Text ist für Kandidaten sichtbar. Achte darauf, dass du geheim bleibst!',
		],
	},
	// [Inquiry.FUNCTION_ASSISTANCE]: {
	// 	property: 'functionAssistance',
	// 	messages: [
	// 		'Welche Assistenz-Tätigkeiten umfasst der Job?',
	// 		'Um das Interesse von potentiellen MitarbeiterInnen zu steigern, gib die Tätigkeiten möglichst detailliert an!',
	// 	],
	// },
	[Inquiry.FUNCTION_LEGAL_FIELD]: {
		property: 'functionLegalField',
		messages: () => [
			'Welche Rechtsgebiete umfasst der Job?',
			'Um das Interesse von potentiellen MitarbeiterInnen zu steigern, gib die Tätigkeiten möglichst detailliert an!',
		],
	},
	[Inquiry.FUNCTION_LEGAL_FIELD_EXPERIENCE]: {
		property: 'functionLegalFieldExperience',
		messages: () => [
			'Wird Erfahrung in bestimmten Rechtsgebieten vorausgesetzt?',
			DEFAULT_EXPERIENCE_INFO
		],
	},
	// [Inquiry.FUNCTION_LEGAL_ROLE]: {
	// 	property: 'functionLegalRole',
	// 	messages: [
	// 		'Welche Rechtstätigkeiten umfasst der Job?',
	// 		'Um das Interesse von potentiellen MitarbeiterInnen zu steigern, gib die Tätigkeiten möglichst detailliert an!',
	// 	],
	// },
	// [Inquiry.FUNCTION_LEGAL_ROLE_EXPERIENCE]: {
	// 	property: 'functionLegalRoleExperience',
	// 	messages: [
	// 		'Wird Erfahrung in bestimmten Rechtstätigkeiten vorausgesetzt?',
	// 	],
	// },
	[Inquiry.FUNCTION_TAX_FIELD]: {
		property: 'functionTaxField',
		messages: () => [
			'Welche Steuergebiete umfasst der Job?',
			'Um das Interesse von potentiellen MitarbeiterInnen zu steigern, gib die Tätigkeiten möglichst detailliert an!',
		],
	},
	[Inquiry.FUNCTION_TAX_FIELD_EXPERIENCE]: {
		property: 'functionTaxFieldExperience',
		messages: () => [
			'Wird Erfahrung in bestimmten Steuergebieten vorausgesetzt?',
			DEFAULT_EXPERIENCE_INFO
		],
	},
	// [Inquiry.FUNCTION_TAX_ROLE]: {
	// 	property: 'functionTaxRole',
	// 	messages: [
	// 		'Welche Steuertätigkeiten umfasst der Job?',
	// 		'Um das Interesse von potentiellen MitarbeiterInnen zu steigern, gib die Tätigkeiten möglichst detailliert an!',
	// 	],
	// },
	// [Inquiry.FUNCTION_TAX_ROLE_EXPERIENCE]: {
	// 	property: 'functionTaxRoleExperience',
	// 	messages: [
	// 		'Wird Erfahrung in bestimmten Steuertätigkeiten vorausgesetzt?',
	// 	],
	// },
	// [Inquiry.FUNCTION_MARKETING_ROLE]: {
	// 	property: 'functionMarketingRole',
	// 	messages: [
	// 		'Welche Marketingtätigkeiten umfasst der Job?',
	// 		'Um das Interesse von potentiellen MitarbeiterInnen zu steigern, gib die Tätigkeiten möglichst detailliert an!',
	// 	],
	// },
	// [Inquiry.FUNCTION_MARKETING_ROLE_EXPERIENCE]: {
	// 	property: 'functionMarketingRoleExperience',
	// 	messages: [
	// 		'Wird Erfahrung in bestimmten Marketingtätigkeiten vorausgesetzt?',
	// 	],
	// },
	[Inquiry.SALARY]: {
		property: 'salary',
		messages: () => [
			'Wie viel kann man verdienen bei dem Job?',
			'Das Gehalt wird den Bewerbern nicht direkt angezeigt, sondern nur verwendet, um passende Übereinstimmungen zu finden.',
		],
	},
	[Inquiry.HOURLY_RATE]: {
		property: 'hourlyRate',
		messages: () => [
			'Welcher Stundensatz ist möglich?',
		],
	},
	[Inquiry.WORKING_HOURS]: {
		property: 'workingHours',
		messages: () => [
			'Bei Teilzeit: Für wie viele Stunden pro Woche sucht ihr jemanden?',
		],
	},
	[Inquiry.LEGITIMATION]: {
		property: 'legitimation',
		messages: () => [
			'Geschafft!',
			'Dein Job wird gleich anonymisiert veröffentlicht!',
			'Bitte beachte, dass Tätigkeit/en, Berufsebene/n und Branche/n nach Veröffentlichung nicht mehr änderbar sind!'
		],
	},
	[Inquiry.EMPLOYMENT_DURATION]: {
		property: 'employmentDuration',
		messages: () => [
			'Wie lange ist die Beschäftigungsdauer?',
		],
	},
	[Inquiry.FUNCTION_EXPERIENCE]: {
		property: 'functionsExperience',
		messages: () => [
			'Sollte man bestimmte Erfahrungen mitbringen für die Tätigkeit?',
			DEFAULT_EXPERIENCE_INFO
		],
	},
	[Inquiry.CAREER_LEVEL_EXPERIENCE]: {
		property: 'careerLevelsExperience',
		messages: () => [
			'Ist Arbeitserfahrung erforderlich, wie zum Beispiel Praktikum, Lehre, als Mitarbeiter, Spezialist oder in Projektleitung, Teamleitung, Management usw.?',
			DEFAULT_EXPERIENCE_INFO
		],
	},
	[Inquiry.INDUSTRIAL_SECTOR_EXPERIENCE]: {
		property: 'industrialSectorsExperience',
		messages: () => [
			'Ist Erfahrung in bestimmten Branchen erforderlich?',
			DEFAULT_EXPERIENCE_INFO
		],
	},
	[Inquiry.SKILLS]: {
		property: 'skills',
		messages: () => [
			'Welche sozialen Kompetenzen braucht man für den Job?',
		],
	},
	[Inquiry.HIRING_DATE]: {
		property: 'hiringDate',
		messages: () => [
			'Wann soll dein neuer Mitarbeiter starten?',
		]
	},
	[Inquiry.LANGUAGE]: {
		property: 'languages',
		messages: () => [
			'Welche Sprachen sollte man beherrschen?',
		],
	},
	[Inquiry.SOFTWARE_MAIN]: {
		property: 'softwareMain',
		messages: () => [
			'Welche Büro-Software muss man bei diesem Job anwenden?',
			'Wichtig: lege nur Muss-Anforderungen fest, da sonst viele Bewerber abgeschreckt werden bzw. ausscheiden.'
		],
	},
	[Inquiry.SOFTWARE_SPECIAL]: {
		property: 'softwareSpecial',
		messages: () => [
			'Welche weitere Software muss man anwenden?',
			'Zum Beispiel Programme für Grafik, Programmiersprachen, Buchhaltung, Musikbearbeitung, Konstruktion, Design, Produktion, Logistik und alle anderen. - Zum Beispiel BMD, SAP FI, Adobe Premiere, AutoCAD, Java, AutoCad.',
			'Nicht gemeint ist damit Bürosoftware für Textverarbeitung, Tabellenkalkulation, Mail/Termin oder Präsentation',
		],
	},
	[Inquiry.PARKING]: {
		property: 'parking',
		messages: () => [
			'Gibt es einen Parkplatz?',
		],
	},
	[Inquiry.BENEFITS]: {
		property: 'benefits',
		messages: () => [
			'Welche Benefits bietet der Job?',
			'Diese Punkte wecken das Interesse von BewerberInnen! Gib daher möglichst alle Vorteile an.',
		],
	},
	[Inquiry.PUBLIC_TRANSPORT]: {
		property: 'publicTransport',
		messages: () => [
			'Wie gut ist die Erreichbarkeit des Arbeitsplatzes mit öffentlichen Verkehrsmitteln?',
			'Auch wenn 100% Homeoffice/Remote möglich ist, gib es bitte an für Personen, die zu euch kommen wollen.'
		]
	},
	[Inquiry.COMPANY_CAR]: {
		property: 'companyCar',
		messages: () => [
			'Bekommt man ein Firmenauto?',
		],
	},
	[Inquiry.PRIVATE_VEHICLE_COMPANY_USAGE]: {
		property: 'privateVehicleCompanyUsage',
		messages: () => [
			'Wird ein Privatauto benötigt für den Berufseinsatz?',
		],
	},
	[Inquiry.CUSTOMER_CONTACT]: {
		property: 'customerContact',
		messages: () => [
			'Hat man Kundenkontakt in dem Job?',
		],
	},
	[Inquiry.MANAGEMENT]: {
		property: 'management',
		messages: () => [
			'Gibt es in dem Job Führungsverantwortung?',
		],
	},
	[Inquiry.OVERTIME]: {
		property: 'overtime',
		messages: () => [
			'Sind Überstunden bei dem Job vorgesehen?',
		],
	},
	[Inquiry.TRAVEL_WILLINGNESS]: {
		property: 'travelWillingness',
		messages: () => [
			'Ist Außendienst bei dem Job vorgesehen?',
		],
	},
	[Inquiry.DRIVING_LICENSE]: {
		property: 'drivingLicense',
		messages: () => [
			'Wird ein Führerschein benötigt?',
		],
	},
	[Inquiry.PILOT_LICENSE]: {
		property: 'pilotLicense',
		messages: () => [
			'Wird ein Flugschein benötigt?',
		],
	},
	[Inquiry.EDUCATION]: {
		property: 'education',
		messages: () => [
			'Wird eine bestimmte Ausbildung für den Job benötigt?',
		],
	},
	[Inquiry.CITIZENSHIP]: {
		property: 'citizenship',
		messages: () => [
			'Ist eine bestimmte Staatsbürgerschaft erforderlich?',
		],
	},
	[Inquiry.HOME_OFFICE_ADVANCED]: {
		property: 'homeOffice',
		messages: () => [
			'Homeoffice, was ist möglich bei diesem Job?',
		],
		addDataOnSkip: true
	},
};

const PRE_FILL_INQUIRIES = {
	[Inquiry.INDUSTRIAL_SECTOR]: {
		property: 'industrialSectors'
	},
	[Inquiry.PLACE_OF_WORK]: {
		property: 'placeOfWork'
	},
	[Inquiry.COMPANY_SIZE]: {
		property: 'companySize'
	},
	[Inquiry.COMPANY_TYPE]: {
		property: 'companyType'
	},
};

export default {

	components: {
		OrganisationalArea,
		CompanySize,
		CompanyType,
		PlaceOfWork,
		IndustrialSector,
		CareerLevel,
		Avatar,
		HomeOffice,
		Label,
		Jon,
		DesireAdditions,
		Education,
		BreakDisplay,
		Legitimation,
		EmploymentDuration,
		WorkingTime,
		Function,
		EmploymentMode,
		FunctionDetail,
		FunctionAssistance,
		FunctionMarketingRole,
		FunctionLegalField,
		FunctionLegalRole,
		FunctionTaxField,
		FunctionTaxRole,
		Citizenship,
		SoftwareSpecial,
		Skills,
		DrivingLicense,
		PilotLicense,
		Management,
		Overtime,
		CustomerContact,
		CompanyCar,
		PublicTransport,
		Benefits,
		SoftwareMain,
		Language,
		HiringDate,
		FunctionExperience,
		CareerLevelExperience,
		IndustrialSectorExperience,
		HourlyRate,
		Button,
		Icon,
		Salary,
		WorkingHours,
		Parking,
		PrivateVehicleCompanyUsage,
		TravelWillingness,
	},

	data ()
	{
		return {
			inquiriesToEdit: undefined,
			initiallyCompletedInquiryIds: [],
			inquiryIndexToEdit: 0,
			allDone: false,
			itemData: {},
			finishingItem: false,
			forcedMessages: undefined,
			publishedJobProfile: false,
			breakType: undefined,
			disabledSkips: [],
			skippedInquiryIds: [],
			seenIndexes: new Set(),
			loadingJobProfileToPreFill: false,
			skip: false,
			performedPreFillCheck: false
		};
	},

	computed: {
		...mapState('jobProfile/questionnaire', [
			'show',
			'jobProfile',
		]),
		...mapState('meta', ['meta']),
		...mapState('layout', ['fanLevelClasses']),
		...mapState('auth', ['customer']),
		jobProfileData ()
		{
			return PreFillPreparation.prepare(this.jobProfile.jobProfile, this.meta);
		},
		mainClass ()
		{
			let classes = ['scrollbar-check'];

			const id = this.inquiriesToEdit[this.inquiryIndexToEdit]?.id;

			if (_.includes([Inquiry.LANGUAGE, Inquiry.SOFTWARE_SPECIAL, Inquiry.PLACE_OF_WORK], id))
			{
				classes.push('flex-grow-1');
			}

			return classes;
		},
		avatarRocket ()
		{
			return ROCKET;
		},
		labelTypeJobProfile ()
		{
			return JOB_PROFILE;
		},
		hideGoBack ()
		{
			const item = this.inquiriesToEdit[this.inquiryIndexToEdit - 1];

			return item?.id === Inquiry.LEGITIMATION;
		},
		canGoBack ()
		{
			return this.inquiryIndexToEdit > 0 && !this.breakType;
		},
		isLegitimation ()
		{
			const item = this.inquiryIndexToEdit >= 0
				? this.inquiriesToEdit[this.inquiryIndexToEdit]
				: null;

			return item?.id === Inquiry.LEGITIMATION;
		},
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['job-bot-questionnaire', 'job-profile-questionnaire']
			});
		},
		isShowItemEditableInfo ()
		{
			const item = this.inquiriesToEdit[this.inquiryIndexToEdit];

			if (!item)
			{
				return false;
			}

			const config = CONFIG[item.id];

			return config?.showItemEditableInfo !== false;
		},
		allItemDataValid ()
		{
			let valid = true;

			_.forEach(_.range(0, this.inquiryIndexToEdit + 1, 1), i =>
			{
				const item = this.inquiriesToEdit[i];

				if (item.id === Inquiry.LEGITIMATION) // skip legitimation, can not have data
				{
					return true; // continue
				}

				if (this.itemData[item.id] === undefined && !_.includes(this.skippedInquiryIds, item.id))
				{
					valid = false;
					return false; // break
				}
			});

			return valid;
		},
		canSkip ()
		{
			if (this.allDone || this.breakType)
			{
				return false;
			}

			if (this.inquiryIndexToEdit >= 0)
			{
				const isSkipped = _.includes(this.disabledSkips, this.inquiriesToEdit[this.inquiryIndexToEdit].id);

				if (isSkipped)
				{
					return false;
				}
			}

			const item = this.inquiriesToEdit[this.inquiryIndexToEdit];

			return item && !item.questionnairePreListing && this.getItemData(item.id) === undefined;
		},
		canContinue ()
		{
			return this.allItemDataValid || !!this.breakType || (this.canSkip && this.skip);
		},
		functionExperienceSupplementTypes ()
		{
			return RELEVANT_SUPPLEMENT_TYPES;
		}
	},

	methods: {
		...mapActions('jobProfile/questionnaire', {
			reloadJobProfile: 'reloadJobProfile',
			closeQuestionnaire: 'close'
		}),
		onDesireAdditionsEdit ()
		{
			this.$nextTick(() =>
			{
				this.scrollBottom();
			});
		},
		getInitialDesires (inquiryId, metaItems)
		{
			const itemData = this.getItemData(inquiryId);

			if (isDefined(itemData))
			{
				return itemData;
			}

			const group = findByInquiryId(this.jobProfile.jobProfile, inquiryId);

			return _.map(
				group?.characteristics || [],
				relation =>
				{
					return {
						item: byId(relation.characteristic.id, metaItems),
						supplements: transformSupplements(relation.supplements)
					}
				}
			);
		},
		addDisableSkip (id)
		{
			if (!_.includes(this.disabledSkips, id))
			{
				this.disabledSkips.push(id);
			}
		},
		scrollBottom ()
		{
			scrollToBottom(this.$refs.main);
		},
		scrollToTop ()
		{
			this.$refs.main.scrollTop = 0;
		},
		goBack ()
		{
			if (!this.canGoBack)
			{
				return;
			}

			this.inquiryIndexToEdit = this.inquiryIndexToEdit - 1;

			const item = this.inquiriesToEdit[this.inquiryIndexToEdit];

			// remove skip when going back
			this.skippedInquiryIds = _.filter(this.skippedInquiryIds, inquiryId => inquiryId !== item.id);

			this.skip = false;

			this.$nextTick(() => this.scrollToTop());
		},
		close ()
		{
			Object.assign(this.$data, this.$options.data.apply(this));

			this.closeQuestionnaire();
		},
		isItemToEdit (itemId, loopIndex)
		{
			const index = _.findIndex(this.inquiriesToEdit, i => i.id === itemId);

			return index >= 0
				&& (index <= this.inquiryIndexToEdit || this.seenIndexes.has(index))
				&& index === loopIndex;
		},
		getItemData (itemId)
		{
			return this.itemData[itemId];
		},
		setItemData (itemId, data)
		{
			this.$set(this.itemData, itemId, data);
		},
		getMessages (inquiryId)
		{
			return CONFIG[inquiryId].messages({customer: this.customer});
		},
		onFinishLegitimation ({publishedJobProfile})
		{
			this.forcedMessages = undefined;
			this.publishedJobProfile = publishedJobProfile;

			this.breakType = TYPE__PRE_EXPERIENCE;
		},
		setForcedMessages (messages, fadeIn)
		{
			this.forcedMessages = fadeIn ? undefined : messages;

			if (fadeIn && messages)
			{
				this.$nextTick(() => this.forcedMessages = messages);
			}
		},
		increaseIndex ()
		{
			this.inquiryIndexToEdit = this.inquiryIndexToEdit + 1;

			this.seenIndexes.add(this.inquiryIndexToEdit);

			// all done
			if (this.inquiryIndexToEdit > (this.inquiriesToEdit.length - 1))
			{
				this.allDone = true;
			}
		},
		async finishItem ()
		{
			if (!this.canContinue)
			{
				return;
			}

			if (this.breakType)
			{
				this.breakType = undefined;
				this.inquiriesToEdit = _.filter(
					this.inquiriesToEdit,
					item => item.id !== Inquiry.LEGITIMATION
				);
				return;
			}

			try
			{
				this.finishingItem = true;

				let data = {};

				_.forEach(_.range(0, this.inquiryIndexToEdit + 1, 1), i =>
				{
					const inquiry = this.inquiriesToEdit[i];

					const config = CONFIG[inquiry.id];

					if (!data[config.property])
					{
						data[config.property] = {};
					}

					const currentSkipped = i === this.inquiryIndexToEdit && this.skip;

					if (currentSkipped)
					{
						this.skippedInquiryIds.push(inquiry.id);
					}

					if (currentSkipped)
					{
						if (config.addDataOnSkip)
						{
							data[config.property] = this.itemData[inquiry.id] || {};
						}

						data[config.property].skipped = true;
					}
					else
					{
						data[config.property] = this.itemData[inquiry.id] || {};

						if (_.includes(this.skippedInquiryIds, inquiry.id))
						{
							data[config.property].skipped = true;

							this.skippedInquiryIds.push(inquiry.id);
						}
					}
				});

				await new Save()
					.setJobProfileId(this.jobProfile.jobProfile.id)
					.setData(
						prepare(data, SOURCE_QUESTIONNAIRE)
					)
					.call();

				await this.reloadJobProfile();

				this.$nextTick(() =>
				{
					this.scrollToTop();
				});

				this.increaseIndex();

				this.skip = false;
			}
			catch (e)
			{
				Log.error(e);

				Toast.error(this, flatten(e.errors));
			}

			this.finishingItem = false;
		},
		async preFillItems (currentJobProfile)
		{
			const response = await new GetList()
				.setExcludeIds([currentJobProfile.id])
				.setOffset(0)
				.setLimit(1)
				.setOrder({'creationDate': 'DESC'})
				.call();

			if (response.data.length > 0)
			{
				const firstJobProfile = _.first(response.data);

				const firstJobProfileData = PreFillPreparation.prepare(firstJobProfile.jobProfile, this.meta);

				_.keys(PRE_FILL_INQUIRIES).forEach(inquiry =>
				{
					if (this.getItemData(inquiry) !== undefined)
					{
						return true; // continue
					}

					const item = PRE_FILL_INQUIRIES[inquiry];

					this.setItemData(inquiry, firstJobProfileData[item.property]);
				});
			}

			this.performedPreFillCheck = true;
		}
	},

	watch: {
		jobProfile (jobProfile)
		{
			if (jobProfile)
			{
				const questionnaireInquiries = jobProfile.questionnaireInquiries;
				const completedInquiriesIncludingSkipped = jobProfile.completedInquiriesIncludingSkipped;

				let inquiriesToEdit;

				if (this.inquiriesToEdit === undefined)
				{
					this.initiallyCompletedInquiryIds = _.cloneDeep(completedInquiriesIncludingSkipped);

					// if initial, set all eligible
					inquiriesToEdit = _.filter(questionnaireInquiries, inquiry =>
					{
						return !_.includes(completedInquiriesIncludingSkipped, inquiry.id);
					});
				}
				else
				{
					const questionnaireInquiryIds = questionnaireInquiries.map(inquiry => inquiry.id);

					// filter out those which are in, but not any longer eligible
					inquiriesToEdit = this.inquiriesToEdit.filter(
						inquiry => questionnaireInquiryIds.includes(inquiry.id)
					);

					const inquiriesToEditIds = inquiriesToEdit.map(inquiry => inquiry.id);

					// now add all new ones, which are not already completed in the first place
					questionnaireInquiries.forEach(inquiry =>
					{
						if (
							inquiriesToEditIds.includes(inquiry.id)
							|| this.initiallyCompletedInquiryIds.includes(inquiry.id)
						)
						{
							return true; // skip
						}

						inquiriesToEdit.push(inquiry);
					});
				}

				this.inquiriesToEdit = _.sortBy(inquiriesToEdit, 'questionnairePriority');

				if (!this.itemData['home-office-advanced'])
				{
					this.setItemData('home-office-advanced', this.jobProfileData.homeOffice);
				}

				this.preFillItems(jobProfile.jobProfile);
			}
		}
	},
}
</script>
